<template>
  <div id="app-center">
    <my-head></my-head>
    <center-head></center-head>
    <div class="center-box">
      <div class="center-list">
        <el-row :gutter="30">
          <el-col :span="4">
            <left-menu></left-menu>
          </el-col>

          <el-col :span="20">
            <div class="center-left">
              <WtDataTable
                ref="tables"
                :listUrl="$db.config.mediaCoverageList"
                :urlParams="{project_type:1}"
              >
                <div slot="buttons">
                  <el-button
                    size="small"
                    style="margin:10px 0px;"
                    icon="el-icon-plus"
                    type="primary"
                    @click="doMedia()"
                  >发布报道</el-button>
                </div>
                <template slot="columns">
                  <el-table-column label="媒体标题" min-width="200" prop="title" align="center">
                    <template slot-scope="scope">
                      <a
                        style="color:rgb(32, 153, 205);cursor: pointer;"
                        @click="look(scope.row)"
                      >{{scope.row.title}}</a>
                    </template>
                  </el-table-column>
                  <el-table-column label="项目名称" prop="project_name" align="center" min-width="150"></el-table-column>

                  <el-table-column label="报道级别" prop="level_text" align="center" min-width="70"></el-table-column>

                  <el-table-column label="报道类型" prop="type_text" align="center" min-width="100"></el-table-column>

                  <el-table-column label="添加时间" prop="addtime" align="center" min-width="100"></el-table-column>

                  <el-table-column label="状态" prop="status_text" align="center" min-width="70"></el-table-column>
                  <el-table-column label="操作" width="180" align="center">
                    <template slot-scope="scope">
                      <el-button-group>
                        <el-button
                          type="primary"
                          icon="el-icon-edit"
                          size="mini"
                          @click="edit(scope.row)"
                        >编辑</el-button>
                      </el-button-group>
                    </template>
                  </el-table-column>
                </template>
              </WtDataTable>

              <media
                v-if="if_open"
                v-model="if_open"
                :pid="$route.query.project_id"
                :id="id"
                :disabled="disabled"
                @success="success"
              ></media>
            </div>
          </el-col>
        </el-row>
      </div>
      <foot-div></foot-div>
    </div>
  </div>
</template>
<script>
import baseUrl from "@/config/index";
import media from "./media_form";
import myHead from "../../public/head";
import centerHead from "../../public/center_head";
import leftMenu from "../../public/menu";
import footDiv from "../../public/foot";
export default {
  components: {
    myHead,
    centerHead,
    leftMenu,
    footDiv,
    media
  },
  data() {
    return {
      if_open: false,
      id: null, //编辑id
      media_title: null,
      disabled: false
    };
  },
  methods: {
    //新增报道
    doMedia() {
      this.id = null;
      this.if_open = true;
      this.disabled = false;
    },
    look(row) {
      this.id = row.id;
      this.if_open = true;
      this.disabled = true;
    },
    edit(row) {
      this.id = row.id;
      this.if_open = true;
      this.disabled = false;
    },

    deleteRow(row) {
      this.$refs.tables.doDelete(row.id);
    },

    success() {
      this.$refs.tables.reloadData();
    }
  },
  created() {}
};
</script>
<style lang="scss" scoped>
#app-center {
  width: 100%;
  // height: 100%;
  background-color: #f1f1f1;
}
.center-box {
  .center-list {
    //max-width: 1200px;
    margin: 0 auto;
    width: 98%;
    padding-top: 20px;
    .center-left {
      background-color: #fff;
      border-top: 2px solid #b60205;
      padding-top: 30px;
      overflow: hidden;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Hospital/comproject/info/media_list.vue